
var reA = /[^a-zA-Z]/g;
var reN = /[^0-9]/g;

var collator = new Intl.Collator('en',{numeric:true, sensitivity:'accent'});

function sort(a, b) {
    console.log(a, b);
  var aA = a.replace(reA, "");
  var bA = b.replace(reA, "");
  console.log(aA, bA);
  if (aA === bA) {
    var aN = parseInt(a.replace(reN, ""), 10);
    var bN = parseInt(b.replace(reN, ""), 10);
    console.log(aN, bN);
    console.log(aN === bN ? 0 : aN > bN ? 1 : -1);
    return aN === bN ? 0 : aN > bN ? 1 : -1;
  } else {
    console.log(aA > bA ? 1 : -1);
    return aA > bA ? 1 : -1;
  }
}
function sort2(a, b) {
    return collator.compare(a, b);
}
export const sortAlphanum = (a, b) => sort2(a, b)